module.exports = __webpack_public_path__ + "static/client_2.1_before-7f59316b48e7dc3065db63ad89173a7b.jpg";